
/**
 * appcontext
    lowcarbprogram
    grohealth
 * runmode
    production
    staging
 * lang
    en-CA
    en-GB
    fr-CA
 * @type {{string}}
 */

module.exports = {
  appcontext: "lowcarbprogram",
  runmode: "production",
  locale:"en-GB"
};



//////////////////
// WEBPACK FOOTER
// ./config/runtimeconf.js
// module id = 1041
// module chunks = 1